














































import {
computed,
defineComponent,
onMounted,
onUnmounted,
Ref,
ref,
useContext,
useRoute,
useRouter,
} from '@nuxtjs/composition-api';
import { SfSteps } from '@storefront-ui/vue';
import { NuxtI18nInstance } from 'nuxt-i18n';
import AppHeader from '~/components/AppHeader.vue';
import AppFooter from '~/components/Footer/AppFooter.vue';
import { getSeoTitle } from '~/components/Seo/utils';
import { useStoryblokNavigationAndFooter } from '~/composables/useStoryblok';
import { StoryblokHeaderAndFooter } from '~/composables/useStoryblok/useStoryblok';
import CartPreview from '~/modules/checkout/components/CartPreview.vue';
import useCart from '~/modules/checkout/composables/useCart';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useCartStore } from '~/modules/checkout/stores/cart';

export default defineComponent({
  name: 'CheckoutPage',
  components: {
    SfSteps,
    CartPreview,
    AppHeader,
    AppFooter,
  },
  setup() {
    const route = useRoute();
    const { app, app: { i18n } } = useContext();
    const { path } = route.value;
    const router = useRouter();
    const { cart, load, hasOnlyGiftCards } = useCart();
    const products = computed(() => cartGetters.getItems(cart.value));
    const currentStep = computed(() => path.split('/').pop());
    const cartStore = useCartStore();

    const STEPS = ref([]);

    const currentStepIndex = computed(() => STEPS.value.findIndex((step) => step.url === currentStep.value));
    const isThankYou = computed(() => currentStep.value === 'danke');

    const handleStepClick = async (stepIndex: number) => {
      if (stepIndex <= currentStepIndex.value) {
        const { url } = STEPS.value[stepIndex];
        await router.push(`${app.localePath(`/checkout/${url}`)}`);
      }
    };

    onMounted(async () => {
      await load();
      if (products.value.length === 0 && currentStep.value !== 'danke') {
        await router.push(app.localePath('/'));
      }

      STEPS.value = [
        {
          title: 'User Account',
          url: 'benutzerkonto',
        },
        ...!hasOnlyGiftCards().value
        ? [{
          title: 'Delivery and Shipping',
          url: 'lieferung',
        }] : [],
        {
          title: 'Billing',
          url: 'rechnung',
        },
        {
          title: 'Payment',
          url: 'bezahlung',
        },
      ];
    });

    const storyblokData: Ref<StoryblokHeaderAndFooter> = useStoryblokNavigationAndFooter();

    onUnmounted(() => {
      cartStore.$patch((state) => {
        state.canShowShippingMethod = false;
      });
    });

    return {
      handleStepClick,
      STEPS,
      currentStepIndex,
      isThankYou,
      currentStep,
      storyblokData,
      hasOnlyGiftCards,
      i18n,
    };
  },
  head() {
    const i18n = (this.i18n as NuxtI18nInstance);
    const title = getSeoTitle(String(i18n.t('Checkout')));
    return {
      title,
      description: i18n.t('The largest bicycle shop in Austria'),
    };
  },
});
